import { cs2Constants } from '../_constants';

export function cs2FileUpload(state = {}, action) {
	
	console.log("action.type: " + action.type);
    switch (action.type) {
        case cs2Constants.FILE_SUBMISSION_REQUEST:
        	return {
        		uploading: true
        	};
        case cs2Constants.FILE_SUBMISSION_SUCCESS:
        	return {
        		uploading: false,
				items: action.submissionResponse.result
        	};
        case cs2Constants.FILE_SUBMISSION_FAILURE: 
        	return {
        		error: action.error
        	};	

		default:
            return state
    }
}